export default __webpack_public_path__ + "static/media/reject.e7ae31ed.svg";